/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum AccountType {
  Direct = "Direct",
}

export const AccountTypeDisplay: Record<AccountType, string> = {
  [AccountType.Direct]: "Direct",
};
